/* tslint:disable jsx-no-lambda */
import * as React from 'react'
import FavoriteTrip from '../../icons/ui/FavoriteTrip'

import Recent from '../../icons/ui/Recent'
import TripPoint from '../../icons/ui/TripPoint'
import SearchTripResult from './SearchTripResult'

const SearchTripListResult = (props: any) => {
  return (
    <div
      className='top1 left0 fit flex wrap result-block absolute bg-light-grey2 overflow-y-scroll border-light-grey4 rounded p1'
      style={{ maxHeight: '20rem', maxWidth: '270px' }}
    >
      {props.recentTrips &&
        props.recentTrips.map((item: any) => (
          <SearchTripResult
            key={item.googlePlaceId}
            item={item}
            icon={<Recent className='mr1' />}
            onChoose={props.onChoose}
          />
        ))}
      {props.favoriteTrips &&
        props.favoriteTrips.map((item: any) => (
          <SearchTripResult
            key={item.googlePlaceId}
            item={item}
            icon={<FavoriteTrip className='mr1' style={{ width: '15px', height: '24px' }} />}
            onChoose={props.onChoose}
          />
        ))}
      {props.riderLocations &&
        props.riderLocations.map((item: any, index: number) => (
          <SearchTripResult
            key={`gpi-${index}`}
            item={item}
            isRiderLocation={true}
            icon={<TripPoint className='mr1 svg-blue' style={{ width: '15px', height: '24px' }} />}
            onChoose={props.onChoose}
          />
        ))}
      {props.googleLocs &&
        props.googleLocs.map((item: any, index: number) => (
          <SearchTripResult
            key={`gpi-${index}`}
            item={item}
            icon={<TripPoint className='mr1' style={{ width: '15px', height: '24px' }} />}
            onChoose={props.onChoose}
          />
        ))}
    </div>
  )
}

export default SearchTripListResult



// WEBPACK FOOTER //
// ./src/components/trips/locations/SearchTripListResult.tsx